<template>
  <div class="container">
    <InventoryInfoSearchWindow @search="search" />
    <InventoryInfoSearchResult :inventoryInfoList="inventoryInfoList" :isExistSearchResult="isExistSearchResult" />
  </div>
</template>

<script>
import InventoryInfoSearchWindow from '@/components/pages/InventoryInfoSearchWindow'
import InventoryInfoSearchResult from '@/components/pages/InventoryInfoSearchResult'

export default {
  name: 'inventory-info-list',
  data () {
    return {
      screenTitle: '[棚卸管理] 棚卸情報一覧',
      inventoryInfoList: [],
      isExistSearchResult: false,
      param: {
        inventoryName: '',
        sectionCode: '',
        inventoryStatus: '',
        latestFlg: '1'
      }
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  created () {
    this.$emit('setMessage', null, false)
    // 棚卸情報リスト取得
    this.get()
  },

  methods: {
    search (inventoryName, sectionCode, inventoryStatus, latestFlg) {
      this.param.inventoryName = inventoryName
      this.param.sectionCode = sectionCode
      this.param.inventoryStatus = inventoryStatus
      this.param.latestFlg = latestFlg

      // 棚卸情報リスト取得
      this.get()
    },

    /**
     * 棚卸情報リストの取得
     */
    async get () {
      this.$emit('setMessage', null, false)
      if (this.$session.get('userDiv') === 2) {
        this.param.sectionCode = this.$session.get('sectionCode')
      }

      // 棚卸情報操作（取得）API
      await this.axios.get('/api/inventory/get', {
        params: this.param,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.inventoryInfoList = response.data.resultList
        if (this.inventoryInfoList.length > 0) {
          this.isExistSearchResult = true
        } else {
          this.isExistSearchResult = false
        }
      })
    }
  },

  components: {
    InventoryInfoSearchWindow,
    InventoryInfoSearchResult
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/InventoryInfoList.vue